// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath stroke=%27rgba%28255, 255, 255, 1%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
}

.navbar-nav {
    display: flex;
    justify-content: center;
    flex: 1 1;
}

.navbar-nav .nav-link {
    margin: 0 35px;
    color: white;
    padding-right: 2px;
    padding-left: 2px;
}

.navbar-nav .nav-link.active,
.navbar-nav .nav-link:hover {
    color: white !important;
    border-bottom: 1px solid #fff;

}

.navbar-toggler {
    border-color: rgba(255, 255, 255, 0.1);
    /* Optional: change the border color */
}

.navbar-toggler-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Responsive */
@media (max-width: 1399px) {
    .navbar-nav .nav-link {
        margin: 0 10px;
    }
}

@media (max-width: 1090px) {
    .navbar-nav .nav-link {
        margin: 0;
    }
}

@media (max-width: 992px) {
    .navbar-nav .nav-link {
        margin-right: 0;
    }

    .navbar-collapse.collapse.show,
    .navbar-collapse.collapsing {
        background-color: #dfc6a9;
        margin-top: -45px;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/Navbar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAO;AACX;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,uBAAuB;IACvB,6BAA6B;;AAEjC;;AAEA;IACI,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,yDAA6Q;AACjR;;AAEA,eAAe;AACf;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,yBAAyB;QACzB,iBAAiB;IACrB;AACJ","sourcesContent":[".navbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 15px;\n}\n\n.navbar-nav {\n    display: flex;\n    justify-content: center;\n    flex: 1;\n}\n\n.navbar-nav .nav-link {\n    margin: 0 35px;\n    color: white;\n    padding-right: 2px;\n    padding-left: 2px;\n}\n\n.navbar-nav .nav-link.active,\n.navbar-nav .nav-link:hover {\n    color: white !important;\n    border-bottom: 1px solid #fff;\n\n}\n\n.navbar-toggler {\n    border-color: rgba(255, 255, 255, 0.1);\n    /* Optional: change the border color */\n}\n\n.navbar-toggler-icon {\n    background-image: url(\"data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba%28255, 255, 255, 1%29' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E\");\n}\n\n/* Responsive */\n@media (max-width: 1399px) {\n    .navbar-nav .nav-link {\n        margin: 0 10px;\n    }\n}\n\n@media (max-width: 1090px) {\n    .navbar-nav .nav-link {\n        margin: 0;\n    }\n}\n\n@media (max-width: 992px) {\n    .navbar-nav .nav-link {\n        margin-right: 0;\n    }\n\n    .navbar-collapse.collapse.show,\n    .navbar-collapse.collapsing {\n        background-color: #dfc6a9;\n        margin-top: -45px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
